<script>
  import SearchSelect from '#lib/SearchSelect.svelte';
  import Popover from '#lib/Popover.svelte';
  import Switch from '#lib/Switch.svelte';
  import ButtonLabel from '#lib/ButtonLabel.svelte';
  import Divider from '#lib/Divider.svelte';
  import FormLabel from '#lib/FormLabel.svelte';
  import t from '#lib/i18n.svelte.js';
  let {
    entry = $bindable(),
  } = $props();

  // NOTE: Only admins can change the page design and collection layout (restrictions is set in DynamicIsland)

  let is_collection_layout_popover_open = $state(false);
  let popover_ref = $state();
  let collection_layout_select_anchor = $state();

  const layout_options = [
    { value: 1, title: t('three_column_grid'), icon: 'three-columns' },
    { value: 2, title: t('four_column_grid'), icon: 'four-columns' },
    { value: 3, title: t('list'), icon: 'image-list' }
  ];

</script>

<SearchSelect
  options={[
    { title: 'Left Aligned Header (Wide)', value: 1 },
    { title: 'Center Aligned Header (Wide)', value: 2 },
    { title: 'Left Aligned Header (Normal)', value: 3 },
    { title: 'Center Aligned Header (Normal)', value: 4 },
  ]}
  bind:value={entry.page_layout}
  allow_null={false}
  enable_search={false}
  show_search_icon={false}
  placeholder={t('page_design')}
  variant='brand ghostly'
/>

<button bind:this={collection_layout_select_anchor} popovertarget='collection_layout_select_popover'>
  <ButtonLabel 
    variant='brand flush' 
    end_icon={is_collection_layout_popover_open ? 'small-arrow-up' : 'small-arrow-down'}
  >
    {t('collection_layouts')}
  </ButtonLabel>
</button>

<!-- TODOO: Create a component for "Multiselect with switches" -->
<Popover
  anchor={collection_layout_select_anchor}
  id='collection_layout_select_popover'
  bind:is_open={is_collection_layout_popover_open}
  bind:ref={popover_ref}
  class='normal'
>
  <div
    class='flex-column'
  >
    <Divider label={t('select_available_layouts_for_viewers')} />
    {#each layout_options as {value, title, icon}}
      <Switch
        value={entry.viewer_available_layouts.includes(value)}
        toggle={() => {
          if (entry.viewer_available_layouts.includes(value)) {
            entry.viewer_available_layouts = entry.viewer_available_layouts.filter(v => v !== value);
          } else {
            entry.viewer_available_layouts = [...entry.viewer_available_layouts, value];
          }
        }}
      >
        <ButtonLabel 
          variant='brand flush'
          start_icon={icon} 
          style={`--icon-color1:${entry.viewer_available_layouts.includes(value) ? 'var(--color-default-foreground)' : 'var(--color-default-foreground-500)'}`} 
        >
          {title}
        </ButtonLabel>
      </Switch>
    {/each}
  </div>
</Popover>

<FormLabel for='allow_enquiry'>{t('allow_enquiry')}</FormLabel>
<Switch 
  id='allow_enquiry' 
  value={entry.allow_enquiry} 
  toggle={() => {
    entry.allow_enquiry = !entry.allow_enquiry;
  }}
/>